import axios from 'axios';
import defaultLogoUrl from '../pawafleet-logo-dark.svg';
import { rootUrl } from '../config/config';

export const DEFAULT_COMPANY_INFO = {
    company_name: 'COSMO FLEETS',
    company_address: '',
    company_phone: '',
    company_email: '',
    company_logo_path: ''
};

export const normalizeCompanyInfo = (source = {}) => ({
    company_name: String(source.company_name ?? DEFAULT_COMPANY_INFO.company_name).trim() || DEFAULT_COMPANY_INFO.company_name,
    company_address: String(source.company_address ?? DEFAULT_COMPANY_INFO.company_address).trim(),
    company_phone: String(source.company_phone ?? DEFAULT_COMPANY_INFO.company_phone).trim(),
    company_email: String(source.company_email ?? DEFAULT_COMPANY_INFO.company_email).trim(),
    company_logo_path: String(source.company_logo_path ?? DEFAULT_COMPANY_INFO.company_logo_path).trim()
});

export const resolveCompanyLogoUrl = (companyInfo) => {
    const normalized = normalizeCompanyInfo(companyInfo);
    if (!normalized.company_logo_path) {
        return defaultLogoUrl;
    }

    if (/^https?:\/\//i.test(normalized.company_logo_path)) {
        return normalized.company_logo_path;
    }

    return `${rootUrl}${normalized.company_logo_path}`;
};

export const fetchCompanyInfo = async (token) => {
    try {
        const response = await axios.get(`${rootUrl}/system/company-info`, {
            headers: token ? { Authorization: `Bearer ${token}` } : undefined
        });

        return normalizeCompanyInfo(response.data?.data || response.data || {});
    } catch (error) {
        return { ...DEFAULT_COMPANY_INFO };
    }
};
